module.exports = __webpack_public_path__ + "img/download-keystore.f8ac3c2c.svg";